// extracted by mini-css-extract-plugin
export default {"fullWidth":"ControlledTextField_fullWidth__Ez15K","labelContainer":"ControlledTextField_labelContainer__NPCMr"};